import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Dropdown, Form, Row, Table } from "react-bootstrap";

export default function Skin({
  body,
  selectedSpecies,
  items,
  loading,
  handleChange,
  handleSubmit,
  setBody,
  skinNo,
  setSkinNo,
}) {
  const handleWeightChange = (e) => {
    const value = e.target.value;

    // Regular expression to allow only positive numbers (integer or decimal)
    const regex = /^\d*\.?\d*$/;

    if (regex.test(value)) {
      handleChange(e); // Only update the state if the value is valid
    }
  };

  return (
    <>
      <Row className="">
        <Col xs={12} xl={6}>
          <Form.Group>
            <Form.Label>Owner</Form.Label>
            <Form.Control
              type="text"
              onChange={handleChange}
              value={body.customer}
              id="customer"
              name="customer"
            />
          </Form.Group>
        </Col>
        <Col xs={12} xl={6}>
          <Form.Group>
            <Form.Label>No of skins</Form.Label>
            <Form.Control
              type="number"
              onChange={(e) => setSkinNo(e.target.value)}
              value={skinNo}
              id="skin_no"
              name="skin_no"
              min={1}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} xl={3}>
          <Form.Group>
            <Form.Label>Weight</Form.Label>
            <Form.Control
              type="text"
              onChange={handleWeightChange}
              value={body.weight}
              id="weight"
              name="weight"
              className="w-100"
            />
          </Form.Group>
        </Col>
        <Col xs={0} xl={3}></Col>
        <Col
          md={12}
          xl={6}
          className="d-md-flex justify-content-xl-end mt-xl-3">
          <Col xs={12} md={6} xl={3} className="pe-2">
            <Button variant="primary" className="w-100" onClick={handleSubmit}>
              Add Item
            </Button>
          </Col>
          <Col xs={12} md={6} xl={3} className="pe-2">
            <Button variant="primary" className="w-100">
              Print
            </Button>
          </Col>
        </Col>
      </Row>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <CircularProgress variant="determinate" value={50} valueBuffer={20} />
        </div>
      ) : (
        <div
          className="table-container table-responsive"
          style={{
            maxHeight: "500px",
            overflow: "auto",
            backgroundColor: "#eee",
          }}>
          {body.production_date ? (
            items.length > 0 ? (
              <Table striped bordered hover className="">
                <thead>
                  <tr>
                    <th>Transaction Id</th>
                    <th>Customer</th>
                    <th>Weight</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr>
                      <td>{item.transaction_id}</td>
                      <td>{item.customer}</td>
                      <td>{item.weight}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center fs-5 py-2">No Items found</div>
            )
          ) : (
            <div className="text-center fs-5 py-2">
              {" "}
              Select date to get items
            </div>
          )}
        </div>
      )}
    </>
  );
}
